import { Button, Input } from "antd";
import qs from "query-string";
import React, { useState } from "react";
import { useHistory } from "react-router";
import BankFeedsCommonLayout from "../../components/bankFeeds/layout";
import { isAllowedBankFeedsRedirect } from "../../utils";

const BankFeedsFakeLogin: React.FC = () => {
  const history = useHistory();
  const { search } = history.location;
  const parsedSearch: any = qs.parse(search);
  const { redirect_uri } = parsedSearch;

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const handleCompleteSubmit = async () => {
    const redirectUriWithPassword = `${redirect_uri}&otp=${encodeURIComponent(
      password,
    )}`;
    // redirect_uri is an attacker-controlled query param; never navigate to a
    // script-executing scheme (javascript: DOM XSS) or, on Airwallex, off our
    // own Link origin (open redirect).
    if (!isAllowedBankFeedsRedirect(redirectUriWithPassword)) {
      return;
    }
    window.location.replace(redirectUriWithPassword);
  };

  return (
    <BankFeedsCommonLayout name={"OAUTH BANK LOGIN PAGE"}>
      <div className="mt-2">
        <Input
          placeholder="Username"
          value={username}
          title="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input
          placeholder="Password"
          type="password"
          value={password}
          title="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button
        className="mt-3"
        type="primary"
        block
        disabled={!password || !username}
        onClick={handleCompleteSubmit}
      >
        Submit
      </Button>
    </BankFeedsCommonLayout>
  );
};

export default BankFeedsFakeLogin;
